import { LoginWrapper, Form } from "./style";
import img from "../../assets/images/pogo2.png";
import img2 from "../../assets/images/pogo2.png";
import { GoPerson } from "react-icons/go";
import { CiLock } from "react-icons/ci";
import { Input } from "antd";
import Button from "../../components/FormElement/Button";
import * as Yup from "yup";
import { useFormik } from "formik";
import login from "../../services/auth";
import jwtDecode from "jwt-decode";
import { useDispatch } from "react-redux";
import {
  setToken,
  setRole,
  setPermissions,
  setUsername,
} from "../../redux/modules/auth/actions";
import { useShowAlert } from "../../hooks/useAlerts";
import Spinner from "../../components/Spinner/FullScreen";
import { AES } from "crypto-js";
import ReCAPTCHA from "react-google-recaptcha";
import { useState } from "react";

const Auth = () => {
  const { error } = useShowAlert();
  const [loading, setLoading] = useState(false);
  const [captureValue, setCaptureValue] = useState(null);
  const dispatch = useDispatch();
  const validationSchema = Yup.object({
    login: Yup.string().required("Kiritish shart!"),
    password: Yup.string().required("Kiritish shart!"),
  });
  const formik = useFormik({
    initialValues: {
      login: "",
      password: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const payload = {
        login: values.login,
        password: values.password,
      };

      setLoading(true);
      login
        .login(payload)
        .then((resp) => {
          const decoded = jwtDecode(resp?.data?.token);
          const secretName = "premiumsoft-admin-panel";
          const secretRole = AES.encrypt(decoded?.role, secretName);
          localStorage.setItem("role", secretRole.toString());
          localStorage.setItem("premiumsoft_access_token", resp?.data?.token);
          let userName = `${decoded?.first_name} ${decoded?.last_name} `;
          localStorage.setItem("username", userName);
          dispatch(setToken(resp?.data?.token));
          dispatch(setRole(decoded?.role));
          dispatch(setUsername(userName));
          dispatch(setPermissions(""));
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          error(
            "Login yoki Parol xato terildi , Iltimos tekshirib qaytadan urinib ko'ring."
          );
        });
    },
  });
  if (loading) return <Spinner />;
  return (
    <div>
      <LoginWrapper>
        <Form onSubmit={formik.handleSubmit}>
          <div className="containr">
            <div className="header">
              <img width={200} src={img} alt="" className="imgLogo" />
              <div className="titles">
                PremiumSoft web <br /> sayti boshqaruv paneli
              </div>
            </div>
            <div className="form">
              <div className="input-wrap">
                <div className="input-from">
                  <Input
                    id="login"
                    name="login"
                    prefix={<GoPerson size={20} className="input-icon" />}
                    status={
                      formik?.errors?.login && formik.touched?.login
                        ? "error"
                        : ""
                    }
                    placeholder="Login"
                    value={formik.values.login}
                    onChange={formik.handleChange}
                  />
                </div>
              </div>
              <div className="input-wrap">
                <div className="input-from">
                  <Input
                    prefix={<CiLock size={20} className="input-icon" />}
                    id="password"
                    name="password"
                    type="password"
                    status={
                      formik?.errors?.password && formik.touched?.password
                        ? "error"
                        : ""
                    }
                    placeholder="Parol"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                  />
                </div>
              </div>
              <div className="recup">
                <ReCAPTCHA
                  sitekey="6LcslNoqAAAAAKxldb-_QdE93iST3PsXctJKdLjj"
                  onChange={(value) => setCaptureValue(value)}
                />
              </div>
              <Button
                text="Kirish"
                htmlType="submit"
                disabled={captureValue ? false : true}
              />
            </div>
            <div style={{ height: "200px" }}></div>
            <div className="footer">
              <div className="footer-title">
                Dastur ishlab chiquvchi:
                <a
                  href="https://premiumsoft.uz/"
                  className="logo"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={img2} alt="" />
                </a>
              </div>
            </div>
          </div>
        </Form>
      </LoginWrapper>
    </div>
  );
};

export default Auth;
